import React from 'react';
import { Redirect } from 'react-router-dom';
import UtilitiesContainer from './Utilities.container';
import { isNullUndefinedOrEmpty } from '../../utils';

const Utilities = props => {

	return <UtilitiesContainer {...props} />;
};

export default Utilities;
